import Marquee from "react-fast-marquee";

const ITEMS = [
    "Relax",
    "Rejuvenate",
    "Rediscover Yourself",
    "Aroma Therapy",
    "Swedish Therapy",
    "Balinese Massage",
    "Thai Dry Massage",
    "Deep Tissue Massage",
    "Jacuzzi",
    "Hammam Bath",
];

const Diamond = () => (
    <svg
        width="9"
        height="9"
        viewBox="0 0 10 10"
        className="mx-10 shrink-0 text-gold/70 md:mx-14"
        aria-hidden="true"
    >
        <rect
            x="2"
            y="2"
            width="6"
            height="6"
            transform="rotate(45 5 5)"
            fill="currentColor"
        />
    </svg>
);

const EditorialMarquee = () => (
    <div
        data-testid="editorial-marquee"
        className="border-y border-gold/20 bg-emerald-900/40 py-7"
        aria-hidden="true"
    >
        <Marquee speed={28} gradient={false} pauseOnHover>
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="whitespace-nowrap font-serif text-2xl uppercase tracking-[0.3em] text-cream/85 md:text-3xl">
                        {item}
                    </span>
                    <Diamond />
                </span>
            ))}
        </Marquee>
    </div>
);

export default EditorialMarquee;
